// Module
var code = `<div class="hotkey-details-panel-groups">
    {{#each groupItems: i}}
        <hotkeysSettingsGroup groupItem="{{groupItems[i]}}" on-ValueChanged="ValueChanged" />
    {{/each}}
</div>`;
// Exports
export default code;